import utils from "../common/util";

const cmpGameHistoryBtn = {
	component: null,

	init: function (element)
	{
		utils.log('cmpGameHistoryBtn initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.deleteBtns = document.getElementsByClassName('game-history-btn__delete-btn');

		_.onClickEvent(element);
	},

	onClickEvent: function (element)
	{
		const _ = this;

		let gameId = element.getAttribute('data-game-id');
		let parentDiv = element.closest('.game-history-btn-container');



		element.addEventListener('click', function (e)
		{
			console.log(element);
			console.log(parentDiv);

			// delete the game
			if ((e.target).closest('.game-history-btn__delete-btn')) {
				fetch(utils.getApiUrl() + '/games/' + gameId, {
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						'Authorization': 'Bearer ' + _.bearerToken
					},
				})
					.then(response => response.json())
					.then(() =>
					{
						parentDiv.classList.add('deleted');
					})
			}
		});
	}
}

export default cmpGameHistoryBtn;
